// Quotations service - moved from database.js
import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  serverTimestamp, 
  db 
} from '../../utils/database/firebase-config';

export const quotationsService = {
  async getQuotations(companyId) {
    try {
      const quotationsRef = collection(db, 'quotations');
      const q = query(quotationsRef, where('companyId', '==', companyId));
      const snapshot = await getDocs(q);
      const quotations = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      
      console.log('📊 Raw quotations from Firestore:', quotations.length);
      
      // Sort in JavaScript to avoid Firestore index issues
      return quotations.sort((a, b) => {
        try {
          const dateA = a.createdAt?.toDate?.() || new Date(a.createdAt || 0);
          const dateB = b.createdAt?.toDate?.() || new Date(b.createdAt || 0);
          return dateB - dateA; // Newest first
        } catch (error) {
          console.warn('Date sorting error:', error);
          return 0; // Keep original order if date parsing fails
        }
      });
    } catch (error) {
      console.error('❌ Error in getQuotations:', error);
      throw error;
    }
  },
  async getQuotation(quotationId) {
    const quotationRef = doc(db, 'quotations', quotationId);
    const snapshot = await getDoc(quotationRef);
    if (snapshot.exists()) return { id: snapshot.id, ...snapshot.data() };
    return null;
  },
  async addQuotation(quotationData) {
    const quotationsRef = collection(db, 'quotations');
    const docRef = await addDoc(quotationsRef, { ...quotationData, createdAt: serverTimestamp(), updatedAt: serverTimestamp() });
    return docRef.id;
  },
  async updateQuotation(quotationId, quotationData) {
    const quotationRef = doc(db, 'quotations', quotationId);
    await updateDoc(quotationRef, { ...quotationData, updatedAt: serverTimestamp() });
    return true;
  },
  async deleteQuotation(quotationId) {
    const quotationRef = doc(db, 'quotations', quotationId);
    await deleteDoc(quotationRef);
    return true;
  }
}; 